const state = {
  showDialog: false,
  // 构件信息
  componentInfo: {},
  // 下载次数
  totalTimes: 0,
  remainTimes: 0,
  // revit插件下载地址
  revitUrl: ''
}
const getters = {
  componentInfo: (state) => { return state.componentInfo },
  versions: (state) => {
    const componentInfo = state.componentInfo
    const versions = componentInfo.softwareVersions || []
    return versions.map((item) => {
      return { label: item.name, value: item.version }
    })
  },
  isR: (state) => { return state.componentInfo.platformCode === 'REVIT' },
  noTimes: (state) => { return state.remainTimes === 0 },
  remainTimes: (state) => { return state.remainTimes },
  totalTimes: (state) => { return state.totalTimes },
  revitUrl: (state) => { return state.revitUrl },
}
const mutations = {
  setShowDialog(state, bool) {
    state.showDialog = bool
  },
  setComponentInfo(state, data) {
    state.componentInfo = data
  },
  setRemainTimes(state, data) {
    state.remainTimes = data
  },
  setTotalTimes(state, data) {
    state.totalTimes = data
  },
  setRevitUrl(state, data) {
    state.revitUrl = data
  },
}
const actions = {
  // 获取用户今日还有多少下载次数
  async loadTimes({ commit }) {
    try {
      const { totalTimes, remainTimes } = await this.$api.user.getDownloadCount()
      commit('setTotalTimes', totalTimes || 0)
      commit('setRemainTimes', remainTimes || 0)
    } catch (error) {
      commit('setTotalTimes', 0)
      commit('setRemainTimes', 0)
    }
  },
  async loadRevitUrl({ commit }) {
    try {
      const data = await this.$api.download.getRevitUrl()
      commit('setRevitUrl', data)
    } catch (error) {
      commit('setRevitUrl', '')
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
